export default "__VITE_ASSET__eb0b8af3__"